import { AgResourceLanguage } from '../types';
import { sharedComponents as EnUsSharedComponents } from '../en-us/sharedComponents';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  ...EnUsSharedComponents,
  outOfStock: 'Agotado',
  comingSoon: 'Próximamente',
  button: {
    cancel: 'Cancelar',
    delete: 'Eliminar',
    remove: 'Eliminar'
  },
  supportCard: {
    title: '¿Necesitas ayuda con tu pedido?',
    description: 'Para más información',
    linkFAQ: 'visita la página de Preguntas Frecuentes',
    email: 'support@athleticgreens.com',
    phone: '1-888-390-4029',
    phoneHref: '+18883904029'
  },
  paymentInfoBackGuarantee: {
    label: 'Garantía de 90 Días de Satisfacción o Devolución de Dinero',
    description: 'Si no te encanta tu AG1 dentro de los primeros 90 días, nosotros te reembolsamos.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pausa, Modifica o Cancela en Cualquier Momento',
    description: 'Ajusta tu suscripción cuando tus necesidades cambien. Tú tienes el control.'
  },
  promoCode: {
    promoButtonLabel: 'Aplicar',
    promoCTA: '¿Tienes un código promocional?',
    promoError: 'Código promocional no válido',
    promoInputLabel: 'Código promocional'
  },
  summaryCheckout: {
    freePrice: 'Gratis',
    discountLabel: 'Tu descuento',
    totalLabel: 'Total',
    taxLabel: 'Impuesto',
    taxNotReady: '---',
    shippingLabel: 'Envío',
    subtotalLabel: 'Subtotal',
    taxEstimatedLabel: 'Impuesto Estimado',
    shippingExpectedPrice: 'Gratis'
  },
  addressForm: {
    firstName: 'Nombre*',
    lastName: 'Apellido*',
    country: 'País/región*',
    addressLine1: 'Dirección',
    addressLine2: 'Apartamento, Suite, Etc',
    city: 'Ciudad',
    province: 'Provincia',
    zipCode: 'Código Postal',
    phone: 'Teléfono',
    company: 'Empresa',
    optional: 'opcional'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Editar Dirección de Envío',
    headerCreate: 'Crear Dirección de Envío',
    headerSelect: 'Seleccionar Dirección de Envío',
    reloadMessage: 'Por favor, recarga la página',
    titleEditAddress: 'Información de Dirección',
    usedSavedLabel: 'Usar dirección guardada',
    useSavedAddressText: 'Elige la dirección de envío para tu pedido.',
    noSavedAddressText: 'Actualmente no tienes direcciones guardadas',
    useSavedAddressButton: 'Usar dirección guardada',
    noSavedAddressButton: 'No hay direcciones guardadas',
    defaultAddress: 'Dirección predeterminada:',
    defaultAddressText: 'Esta dirección se utilizará para tu suscripción.',
    otherAddresses: 'Otras Direcciones',
    cancelEditButton: 'Cancelar',
    updateEditButton: 'Actualizar',
    saveButton: 'Guardar',
    cancelSelectButton: 'Cancelar',
    updateSelectButton: 'Usar seleccionado',
    submitSelectButton: 'Ok',
    massUpdate: 'Usar para todas las suscripciones activas',
    subscriptionUpdate: 'Establecer como dirección de envío para mi suscripción',
    giftTitle: 'Enviar como regalo',
    giftRecipientEmailLabel: 'Correo Electrónico del Destinatario*',
    giftMessageLabel: 'Mensaje de Regalo',
    giftAddressClosingAlert: {
      title: 'Cerrar Dirección de Envío del Regalo',
      content:
        '¿Estás seguro de que deseas cerrar sin actualizar la dirección de envío? Tu regalo será enviado a tu dirección predeterminada',
      editAddressButton: 'Editar dirección',
      confirmButton: 'Confirmar'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Eliminar Dirección',
    description: '¿Estás seguro de que deseas eliminar la dirección guardada?',
    cancelButton: 'Cancelar',
    deleteButton: 'Eliminar'
  },
  addressVerified: {
    title: 'Confirma Tu Dirección',
    text: 'No pudimos verificar la dirección exacta que has introducido. Verifica si es correcta o realiza los cambios necesarios.',
    suggested: 'Dirección Sugerida',
    entered: 'Dirección Introducida',
    edit: 'Editar Dirección',
    continue: 'Guardar y Continuar'
  },
  giftLabel: {
    short: 'Regalo',
    long: 'Tu Regalo'
  },
  v53: {
    originalFlavorTitle: 'Original',
    upgradedFormulaText: 'FÓRMULA MEJORADA',
    selectFlavorText: 'Seleccionar Sabor',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
